import React, { ReactNode } from 'react'

import classes from './with-css-wrapper.module.scss'

export const withCSSExtra = (storyFn: () => ReactNode) => (
  <div className={classes.wrapper}>{storyFn()}</div>
)
